import axios from 'axios';
import { API_URL}  from '../utils/helper';
import http from '../utils/http';

const user = JSON.parse(localStorage.getItem('user'))?.user;
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export default {
    state: initialState,
    mutations: {
        setUser(state, payload) {
            state.user = payload;
            if (state.user) {
                state.status.loggedIn = true;
            }
            else {
                state.status.loggedIn = false;
            }  
        },
    },
    actions: {
        async registration({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            const user_data = {
                name: payload.name,
                phone: payload.phone,
                email: payload.email,
                password: payload.password 
            }

            const promo_data = {
                email: payload.email,
                code: payload.code  
            }
            try {
                const candidate = await axios.post(`${API_URL}/auth/logup`, user_data, { withCredentials: true });
                //update role
                const new_role_user = await axios.post(`${API_URL}/promo/activate`, promo_data);
                
                if (candidate && new_role_user) {
                    const userData = new_role_user.data;
                    const user = {
                        name: userData.name,
                        id: userData.id,
                        phone: userData.phone,
                        email: userData.email,
                        isActivated: userData.isActivated,
                        role: userData.role,
                        promoId: userData.promoId
                    }
                    localStorage.setItem('user', JSON.stringify({ user: user, token: candidate.data.accessToken }));
                    commit('setUser', userData.user);
                }                
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async login({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const response = await axios.post(`${API_URL}/auth/login`, payload, { withCredentials: true });
                if (response && response.data) {

                    const userData = response.data;
                    
                    const user = {
                        name: userData.user.name,
                        id: userData.user.id,
                        promoId: userData.user.promoId,
                        phone: userData.user.phone,
                        email: userData.user.email,
                        isActivated: userData.user.isActivated,
                        role: userData.user.role
                    }
                    localStorage.setItem('user', JSON.stringify({ user: user, token: userData.accessToken }));
                    commit('setUser', userData.user);
                }               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async createAdm({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const response = await axios.post(`${API_URL}/auth/adm-create`, payload, { withCredentials: true });
                if (response && response.data) {

                    const userData = response.data;
                    
                    const user = {
                        name: userData.user.name,
                        id: userData.user.id,
                        email: userData.user.email,
                        role: userData.user.role
                    }
                    localStorage.setItem('user', JSON.stringify({ user: user, token: userData.accessToken }));
                    commit('setUser', userData.user);
                }               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async logout({commit}, payload) {
            commit('clearError');
            try {
               const response = await http.post(`/auth/logout`, payload);
                if (response) {
                    localStorage.removeItem('user');
                    localStorage.removeItem('locale');
                }
                commit('setUser', null);
                commit('setLoading', false); 
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error  
            } 
        },
        async checkAuth({commit}) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const response = await axios.get(`${API_URL}/token/refresh`, { withCredentials: true });
                if (response && response.data) {
                    const userData = response.data;
                    const user = {
                        name: userData.user.name,
                        id: userData.user.id,
                        phone: userData.user.phone,
                        email: userData.user.email,
                        isActivated: userData.user.isActivated,
                        role: userData.user.role
                    }
                    localStorage.setItem('user', JSON.stringify({ user: user, token: userData.accessToken }));
                    commit('setUser', response.data.user);
                }               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        //activation promo-code => change the role to PROFESSOR
        async checkPromo({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await axios.post(`${API_URL}/promo/activation`, payload);
                if (result) {
                    
                    const user = await result.data;
                    const prev_user = JSON.parse(localStorage.getItem('user'));
                    
                    if (prev_user && prev_user.token) {
                        //rewriting the user in LocalSorage
                        const token = prev_user.token;
                        localStorage.removeItem('user');
                        localStorage.setItem('user', JSON.stringify({ user: user, token: token }));
                    }

                    commit('setUser', user);
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
    },
    getters: {
        user (state) {
            return state.user;
        },
        loggedIn (state) {
            return state.status.loggedIn;
        },
        isAdmin (state) {
            if (state.user && state.user.role == 'ADMIN') {
                return true
            }
            return false
        }
    }
}